import * as Library from '../library/index';
import { Base } from './base';

/**
 * Class: Item
 */
export class Action extends Base {
  public onClick: any;

  /**
   * hasClick()
   * @returns {*}
   */
  hasClick() {
    return Library.isFunction(this.onClick);
  }

  /**
   * Constructor()
   * @param options
   */
  constructor(options) {
    super(options);
    this.onClick = Library.init(options, 'onClick');
  }
}
